function component(name) {
  return function decorator(target) {
    target.componentName = name;
  }
}

class Block {
  constructor (context) {
    this._name = this.constructor.componentName
    this._modifiers = {}
    this._elements = {}

    this.context = Block.context(context);
    this.el = Block.find(this.context, this.className());

    if(!this.el) {
      throw new Error(`Provided context doesn't contain elements with class name ${this.className()}`)
    }
  }
  
  element(name) {
    if(this._elements[name]) {
      return this._elements[name]
    }

    this._elements[name] = new Element(name, this)
    
    return this._elements[name]
  }
  
  modifier(name) {
    if(this._modifiers[name]) {
      return this._modifiers[name]
    }

    this._modifiers[name] = new Modifier(name, this)

    return this._modifiers[name]
  }
  
  className() {
    return this._name
  }
  
  static find(context, className) {
    if (context.classList.contains(className)) {
      return context
    }
    
    return context.querySelector(`.${className}`)
  }
  
  static context(context) {
    return context || document.documentElement
  }
  
  list(ListedBlock) {
    if(!ListedBlock.componentName) {
      throw new Error(`${ListedBlock.constructor.name} must declare static property 'name'`)
    }
    
    return Array.from(this.el.querySelectorAll(`.${ListedBlock.componentName}`))
      .map((element) => new ListedBlock(element))
  }
  
  /**
   * Returns list of ListedBlock type blocks
   * 
   * @param ListedBlock
   * @param context
   * @return Array<ListedBlock>
   */
  static list (ListedBlock, context) {
    const listContext = Block.context(context)
    if(!ListedBlock.componentName) {
      throw new Error(`${ListedBlock.constructor.name} must declare static property 'name'`)
    }
    return Array.from(listContext.querySelectorAll(`.${ListedBlock.componentName}`)).map((element) => new ListedBlock(element))
  }
}

class Element {
  constructor (name, parent) {
    this._name = name
    this._parent = parent

    this.list = this._getElementItems()
  }
  
  _getElementItems() {
    return Array.from(this._parent.el.querySelectorAll(`.${this.className()}`)).map((item) => new ElementItem(item, this))
  }
  
  className() {
    return this._parent.className() + Element.SEPARATOR + this._name
  }

  first() {
    return this.list[0]
  }

  create(tagName) {
    let newDomItem = document.createElement(tagName)
    newDomItem.className = this.className()
    let newElementItem = new ElementItem(newDomItem, this)
    this.list.push(newElementItem)
    return newElementItem
  }

  each() {

  }
}

class ElementItem {
  constructor (domElement, element) {
    this.el = domElement
    this._element = element
    this._modifiers = {}
  }

  modifier(name) {
    if(this._modifiers[name]) {
      return this._modifiers[name]
    }

    this._modifiers[name] = new Modifier(name, this)

    return this._modifiers[name]
  }

  clone() {
    let cloned = this.el.cloneNode(false)
    let elementItem = new ElementItem(cloned, this._element)
    this._element.list.push(elementItem)
    return elementItem
  }

  className() {
    return this._element.className()
  }
}

class Modifier {
  constructor (name, parent) {
    this._name = name
    this._parent = parent
  }
  
  className() {    
    return this._parent.className() + Modifier.SEPARATOR + this._name
  }
  
  on() {
    this._parent.el.classList.add(this.className())
  }
  
  off() {
    this._parent.el.classList.remove(this.className())
  }

  isOn() {
    return this._parent.el.classList.contains(this.className())
  }

  toggle() {
    if(this.isOn()) {
      this.off()
    }
    else {
      this.on()
    }
  }
}

Element.SEPARATOR = '-'
Modifier.SEPARATOR = '--'

export {
  component,
  Block,
  Element,
  Modifier
}



// WEBPACK FOOTER //
// ./scripts/core/Component.js